export default __webpack_public_path__ + "static/media/Group 851.d642a5a5.zip";